import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../../Miscelania/RequestApi';
import InputMask from 'react-input-mask';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';

import ScheduleGradeOffScheduleLineTab from './ScheduleGradeOffScheduleLineTab';
import ScheduleGradePlanningEdit from './ScheduleGradePlanningEdit';
import ScheduleGradePlanningAdd from './ScheduleGradePlanningAdd';
// Importação da tabela
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';

class ScheduleGradeVacationTab extends Component {
  constructor(props) {
    super(props);
    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'closed',
      },
      redirect_url: false,
      loaded: 0,
      staffs_index: [],
      vacations_schedules: [],
      unavailable_staff_ids: [],
      staffs_planning: [],
      staffs: [],
      edit_plannings: [],
      add_planning: {
        start: null,
        finish: null,
        staff_id: null,
        extra_salary: false,
        days: 0,
        planning_id: null,
        staff_vacations_select: [],
      },
      add_planning_data: {},
      vacations: {},
      schedule: {},
      modal_vacation: false,
      date_start: null,
      date_finish: null,
      staff_id: null,
      add_date_start: null,
      add_date_finish: null,
      add_staff_id: null,
      schedule_grade_group_staff_id: '',
    };

    this.openModal = this.openModal.bind(this);
    this.openVacationModal = this.openVacationModal.bind(this);
    this.add = this.add.bind(this);
    this.addFerias = this.addFerias.bind(this);
    this.delete = this.delete.bind(this);
    this.edit = this.edit.bind(this);
    this.resetPlanningData = this.resetPlanningData.bind(this);
  }
  // Handlers
  handleChange (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }
  handleSelectChange(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
    }
    this.setState(change);
  }

  // LM
  componentWillReceiveProps(newProps) {

    if((this.state.loaded === 0 && Array.isArray(newProps.staffs) && Array.isArray(newProps.vacations_schedules) && Array.isArray(newProps.unavailable_staff_ids) && Array.isArray(newProps.staffs_planning) && typeof newProps.schedule.id !== 'undefined') || (this.state.loaded === 1 && newProps.updated === 1)) {
      this.setState({
        staffs_index: newProps.staffs_index,
        vacations_schedules: newProps.vacations_schedules,
        staffs_planning: newProps.staffs_planning,
        vacations: newProps.vacations,
        unavailable_staff_ids: newProps.unavailable_staff_ids,
        schedule: newProps.schedule,
        staffs: newProps.staffs,
        loaded: 1,
      });
    }
  }


  // Deleta um colaborador na escala
  delete(schedule_grade_group_staff_id) {
    var confirm = window.confirm('Tem certeza que gostaria de deletar esse colaborador?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/grupo/colaborador/' + schedule_grade_group_staff_id, { method: 'DELETE', mode: 'cors', headers: value}).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          self.props.updateData(responseJson);
        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Adiciono uma aeronave na escala
  openVacationModal(event) {
    event.preventDefault();
    this.setState({
      modal_vacation: true,
    });
  }


  addFerias (cell, row) {
    return  <ScheduleGradeOffScheduleLineTab schedule={this.state.schedule} unavailable_staff_ids={this.state.unavailable_staff_ids} schedule_id={this.state.schedule.id} schedule_grade_id={this.props.schedule_grade_id} updateData={this.props.updateData} updated={this.state.updated} handleAlert={this.props.handleAlert} staff={row} />;
  }

  // Adiciono uma aeronave na escala
  openModal(event) {
    this.setState({
      modal: true,
      date_start: event.date_start,
      date_finish: event.date_finish,
      staff_id: event.staff_id,
      schedule_grade_aircraft_staff_id: event.sggs_id,
    });
  }

  // Adiciono uma aeronave na escala
  edit(event) {
    var confirm = window.confirm('Tem certeza que gostaria alocar este colaborador para férias?');
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.props.schedule_id,
        schedule_grade_id: this.props.schedule_grade_id,
        staff_id: this.state.staff_id,
        date_start: this.state.date_start,
        date_finish: this.state.date_finish,
        schedule_grade_group_staff_id: this.state.schedule_grade_aircraft_staff_id,
        change_schedule: event,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/editar/ferias', { method: 'PUT', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status == 'success') {

            self.props.updateData(responseJson);
          } else {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          }

        }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  // Adiciono uma aeronave na escala
  add(event) {
    var confirm_text = "Tem certeza que gostaria alocar este colaborador para férias?";
    if(this.state.unavailable_staff_ids.includes(this.state.add_staff_id)) {
      confirm_text = "ATENÇÂO! O colaborador está escalado, prosseguir mesmo assim?";
    }
    var confirm = window.confirm(confirm_text);
    if (confirm) {
      this.props.handleAlert('', '', 'open');
      var datasave = {
        schedule_id: this.props.schedule_id,
        schedule_grade_id: this.props.schedule_grade_id,
        staff_id: this.state.add_staff_id,
        date_start: this.state.add_date_start,
        date_finish: this.state.add_date_finish,
        change_schedule: event,
      };
      var header = this.refs.request_api.header('application/json');
      var self = this;
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/escala/grade/adicionar/ferias', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if(responseJson.status === 'info') {
            self.setState({
              modal_plannings: true,
              edit_plannings: responseJson.data,
            });
            self.props.handleAlert('', '', 'closed');
          } else if(responseJson.status === 'warning') {
            self.setState({
              modal_add_plannings: true,
              add_planning: {
                start: datasave.date_start,
                finish: datasave.date_finish,
                staff_id: datasave.staff_id,
                extra_salary: false,
                days: 0,
                planning_id: responseJson.data.planning_id,
                staff_vacations_select: responseJson.data.staff_vacations_select,
              },
            });
            self.props.handleAlert('', '', 'closed');
          }else if(responseJson.status == 'error') {
            self.props.handleAlert(responseJson.message, responseJson.status, 'open');
          } else {
            self.props.updateData(responseJson);
          }
          self.setState({
            modal_vacation: false,
          });
      }).catch((error) => {
          console.error(error);
        });
      });
    }
  }

  resetPlanningData () {
    this.setState({
      add_planning: {
        start: null,
        finish: null,
        staff_id: null,
        extra_salary: false,
        days: 0,
        planning_id: null,
        staff_vacations_select: [],
      },
    });
  }

  render() {
    var self = this;
    return (
<div>
  <RequestApi ref={'request_api'} />
  <h3 className="page-title">Colaboradores de férias</h3>
  <hr/>
  <h3>Adicionar colaborador</h3>
  <hr/>
  <form onSubmit={this.openVacationModal}>
    <div className="row">
      <div className="col-md-4 form-group">
        <label>Colaborador:</label>
        <Select
          className="form-field-name"
          name="add_staff_id"
          value={this.state.add_staff_id}
          searchable={true}
          placeholder={''}
          onChange={this.handleSelectChange.bind(this, 'add_staff_id')}
          options={this.state.staffs}
          required
        />
      </div>
      <div className="col-md-4 form-group">
        <label>Data inicial:</label>
        <InputMask value={this.state.add_date_start}  maskChar={null} name="add_date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'add_date_start')} placeholder="" />
      </div>
      <div className="col-md-4 form-group">
        <label>Data final:</label>
        <InputMask value={this.state.add_date_finish}  maskChar={null} name="add_date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'add_date_finish')} placeholder="" />
      </div>
    </div>
    <button type="submit" className="btn btn-primary btn-block"><i className="fa fa-fw fa-save"></i> Adicionar colaborador</button>
  </form>
  <hr/>
  <table className="table table-hover table-stripped table-bordered">
    <thead>
      <tr>
        <th className="text-center">Colaborador</th>
        <th className="text-center">Função</th>
        <th className="text-center">Período</th>
        <th className="text-center">Ações</th>
      </tr>
    </thead>
    <tbody>
      {Object.keys(self.state.vacations).map(function(period) {
        return(
          Object.keys(self.state.vacations[period]).map(function(k) {
            var vacation = self.state.vacations[period][k];
            return(
              <tr>
                <td style={{width: '6%'}} className="text-center">{vacation.name}</td>
                <td style={{width: '6%'}} className="text-center">{vacation.role}</td>
                <td style={{width: '8%'}} className="text-center">{vacation.period}</td>
                <td style={{width: '7%'}} className="text-center">
                  <button onClick={() => {self.openModal(vacation)}} className="btn btn-xs btn-primary"><i className="fa fa-fw fa-pencil"></i></button>
                  <button onClick={() => {self.delete(vacation.sggs_id)}} className="btn btn-xs btn-danger"><i className="fa fa-fw fa-trash"></i></button>
                </td>
              </tr>
            );
          })
        );
      })}
    </tbody>
  </table>
  <hr/>
  <h3 className="page-title">Colaboradores escalados em planejamento de férias</h3>
  <hr/>

  <BootstrapTable data={self.state.staffs_planning} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há colaboradores em planejamento de férias'}} search={true} multiColumnSearch={true} searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
    <TableHeaderColumn dataField="date_start_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="130">Data inicial</TableHeaderColumn>
    <TableHeaderColumn dataField="date_finish_str" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="130">Data final</TableHeaderColumn>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.addFerias} width="400">Ações</TableHeaderColumn>
  </BootstrapTable>
  <hr/>
  <h3 className="page-title">Colaboradores que não completaram suas férias do mês anterior</h3>
  <hr/>
  <BootstrapTable data={self.state.vacations_schedules} pagination={true} striped={true} hover={true} exportCSV={true} options={{exportCSVText: 'Exportar CSV', noDataText: 'Não há colaboradores com férias incompletas'}} search={true} multiColumnSearch={true} searchPlaceholder='Procurar'>
    <TableHeaderColumn dataField="name" isKey={true} dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}}>Nome</TableHeaderColumn>
    <TableHeaderColumn dataField="days" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="130">Dias férias</TableHeaderColumn>
    <TableHeaderColumn dataField="base" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="130">Base</TableHeaderColumn>
    <TableHeaderColumn dataField="period" dataAlign="center" dataSort={true} filter={{type: 'TextFilter', delay: 200, placeholder: 'Procurar'}} width="200">Férias de:</TableHeaderColumn>
    <TableHeaderColumn dataField="id" dataAlign="center" dataFormat={this.addFerias} width="400">Ações</TableHeaderColumn>
  </BootstrapTable>
  <Modal show={self.state.modal} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Editar período de férias do colaborador</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal: false, schedule_grade_aircraft_staff_id: null, date_start: null, date_finish: null, staff_id: null, schedule_grade_aircraft_edit: {}});}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
      <hr/>
      <h4>Será feita a alteração na escala do mês seguinte, caso o colaborador esteja escalado?</h4>
      <p>Obs.: Essa ação abrirá uma nova revisão caso a grade ja esteja aprovada. Igualando o primeiro dia do mês seguinte, com o último dia do período do colaborador nesta escala.</p>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
        <div className="col-md-6">
          <label>Data inicial:</label>
          <InputMask value={this.state.date_start}  maskChar={null} name="date_start" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_start')} placeholder="" />
        </div>
        <div className="col-md-6">
          <label>Data final:</label>
          <InputMask value={this.state.date_finish}  maskChar={null} name="date_finish" mask="99/99/9999" className="form-control" onChange={this.handleChange.bind(this, 'date_finish')} placeholder="" />
        </div>
      </div>
      <hr/>
      <div className="row">
          <div className="col-md-6">
            <button onClick={() => {self.edit(true);}} className="btn btn-block btn-success"><i className="fa fa-fw fa-save"></i> SIM</button>
          </div>
          <div className="col-md-6">
            <button onClick={() => {self.edit(false);}} className="btn btn-block btn-danger"><i className="fa fa-fw fa-save"></i> NÂO</button>
          </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal: false, schedule_grade_aircraft_staff_id: null, date_start: null, date_finish: null, staff_id: null, schedule_grade_aircraft_edit: {}});}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  <Modal show={self.state.modal_plannings} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Editar período de férias do colaborador</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_plannings: false, edit_plannings: []}); self.props.handleAlert('', '', 'open'); self.props.updateData({data: [], status: 'success', message: 'Colaborador adicionado com sucesso.'})}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <p><strong>Esse colaborador possui registro(s) para o ano-base no Planejamento de Férias, selecione o(s) registro(s) que deseja alterar:</strong></p>
      <hr />
      {Object.keys(self.state.edit_plannings).map(function(k) {
        var vacation = self.state.edit_plannings[k];
        return(
          <ScheduleGradePlanningEdit handleAlert={self.props.handleAlert} edit_planning={vacation} />
        );
      })}
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_plannings: false, edit_plannings: []}); self.props.handleAlert('', '', 'open'); self.props.updateData({data: [], status: 'success', message: 'Colaborador adicionado com sucesso.'})}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  <Modal show={self.state.modal_add_plannings} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4 className="pull-left">Adicionar período de férias do colaborador</h4>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_add_plannings: false}); self.resetPlanningData(); self.props.handleAlert('', '', 'open'); self.props.updateData({data: [], status: 'success', message: 'Colaborador adicionado com sucesso.'})}}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <p><strong>Esse colaborador não possui registro(s) para o ano-base no Planejamento de Férias, deverá ser adicionado um novo registro com as datas selecionadas:</strong></p>
      <hr />
      <ScheduleGradePlanningAdd handleAlert={self.props.handleAlert} add_planning={self.state.add_planning} />
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_add_plannings: false}); self.resetPlanningData(); self.props.handleAlert('', '', 'open'); self.props.updateData({data: [], status: 'success', message: 'Colaborador adicionado com sucesso.'})}}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

  <Modal show={self.state.modal_vacation} aria-labelledby="contained-modal-alert-title-lg" bsSize={'large'}>
    <Modal.Header>
      <h4>Será feita a alteração na escala do mês seguinte, caso o colaborador esteja escalado?</h4>
      <p>Obs.: Essa ação abrirá uma nova revisão caso a grade ja esteja aprovada. Igualando o primeiro dia do mês seguinte, com o último dia do período do colaborador nesta escala.</p>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_vacation: false}); self.props.handleAlert('', '', 'open'); }}><i className="fa fa-fw fa-close"></i></button>
      <div className="clearfix"></div>
    </Modal.Header>
    <Modal.Body>
      <div className="row">
          <div className="col-md-6">
            <button onClick={() => {self.add(true);}} className="btn btn-block btn-success"><i className="fa fa-fw fa-save"></i> SIM</button>
          </div>
          <div className="col-md-6">
            <button onClick={() => {self.add(false);}} className="btn btn-block btn-danger"><i className="fa fa-fw fa-save"></i> NÂO</button>
          </div>
      </div>
    </Modal.Body>
    <Modal.Footer>
      <button className="btn btn-danger btn-sm pull-right" onClick={() => {self.setState({modal_vacation: false}); self.props.handleAlert('', '', 'open'); }}><i className="fa fa-fw fa-close"></i></button>
    </Modal.Footer>
  </Modal>

</div>
    );
  }
}

export default ScheduleGradeVacationTab;



// WEBPACK FOOTER //
// ./src/Components/ScheduleGrades/Elements/ScheduleGradeVacationTab.js